import * as React from 'react';
import * as _ from 'underscore';
import { imgPath } from '../../common/utilities/ImgUrl';
import { NotificationCenterStyles } from '../styles/notificationCenterStyles';
import { TextLinkWidget, TextLinkKind } from '@tableau/widgets';
import { UserNotificationActions } from '../redux/UserNotificationActions';
import { IUserNotification } from '../models/IUserNotification';
import { NotificationDisplayMode } from './NotificationPanel';

export type NotificationPanelHeaderProps = {
  userPreferenceUrl: string;
  isMarkAllReadDisabled: boolean;
  userNotificationActions: UserNotificationActions;
  userNotifications: _.Dictionary<IUserNotification>;
  displayMode: NotificationDisplayMode;
};

export class NotificationPanelHeader extends React.PureComponent<NotificationPanelHeaderProps> {

  constructor(props: NotificationPanelHeaderProps) {
    super(props);
    this.markAllAsRead = this.markAllAsRead.bind(this);
  }

  private markAllAsRead() {
    const ids = _.keys(_.pick(this.props.userNotifications, (value: IUserNotification) => !value.read));
    this.props.userNotificationActions.updateUserNotificationsStatus(ids, true);
  }

  public render() {
    //TODO update localized string once finalized
    return <div id={'notification-panel-header'} className={NotificationCenterStyles.notificationPanelHeaderContainer}>
      <div>Notifications</div>
      {
        (this.props.displayMode === NotificationDisplayMode.NotificationLoading) ? <span /> :
          <div>
            {
              (this.props.isMarkAllReadDisabled) ? <span style={NotificationCenterStyles.notificationMarkAllReadLinkDisabled}>Mark all as read</span> :
                (
                  <TextLinkWidget
                    aria-label={'Mark all as read'}
                    kind={TextLinkKind.LowEmphasis}
                    onClick={this.markAllAsRead}
                    testId='mark-all-read-link'
                    style={NotificationCenterStyles.notificationMarkAllReadLink}
                    tabIndex={0}>
                    Mark all as read
                  </TextLinkWidget>
                )
            }
            <a href={this.props.userPreferenceUrl} tabIndex={0} className={NotificationCenterStyles.userPreferenceLink}><img src={imgPath('spaces_navigation_admin_settings.svg')} alt={'user preference'} /></a>
          </div>
      }
    </div>;
  }

}